import cx from 'classnames'
import { useLayoutEffect, useRef } from 'react'
import { animated, useSpring } from 'react-spring'

export interface ChatTypeButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  isActive: boolean
  unreadCount?: number
  onLayout: (el: HTMLButtonElement) => void
}

export function ChatTypeButton ({ children, isActive, unreadCount, className, onLayout, ...rest }: ChatTypeButtonProps): JSX.Element {
  let ref = useRef<HTMLButtonElement>(null)

  let count = useSpring({
    value: unreadCount ?? 0
  })

  useLayoutEffect(() => {
    if (!ref.current) {
      return
    }

    onLayout(ref.current)
  }, [ onLayout ])

  return (
    <animated.button
      ref={ref}
      type='button'
      className={cx(className, 'px-2 py-3 pb-3 rounded flex gap-1.5 items-center transition-colors duration-300 uppercase select-none', {
        'text-gray-800': !isActive,
        'text-blue-600': isActive
      })}
      {...rest}
    >
      <div className='font-roboto text-xs font-medium whitespace-nowrap flex items-center justify-center'>
        {children}
      </div>

      {typeof unreadCount === 'number' && unreadCount > 0 && (
        <animated.span
          className={cx('w-4 h-4 rounded-full font-roboto font-semibold flex items-center justify-center text-[0.5rem] overflow-hidden transition-colors duration-500', {
            'bg-blue-600 text-white': isActive,
            'bg-gray-300 text-gray-800': !isActive
          })}
        >
          {count.value.to(v => v.toFixed(0))}
        </animated.span>
      )}
    </animated.button>
  )
}
